var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HTML_MEDIAVIDEO"},[(_vm.datas.videos && _vm.datas.videos.length > 0)?[_c('video_aliplayer_v2',{attrs:{"options":{
        // source: '//player.alicdn.com/video/editor.mp4',
        source: _vm.datas.videos[1] ? _vm.datas.videos[1] : '',
        cover: _vm.datas.videos[0] ? _vm.datas.videos[0] : '',
      }}})]:[_c('img',{attrs:{"src":_vm.datas.pictures[0] ? _vm.datas.pictures[0] : ''}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }